import { ConfigProvider } from "antd";
import { useEffect } from "react";
import "@ant-design/v5-patch-for-react-19";
import { createGlobalStyle } from "./styles";
import { genericStyles } from "../../../constant";

const AntdThemeWrapper = ({ children }) => {
  useEffect(() => {
    const styleTag = document.createElement("style");
    createGlobalStyle(styleTag);
    document.head.appendChild(styleTag);
    return () => {
      document.head.removeChild(styleTag);
    };
  }, []);

  return (
    <ConfigProvider
      theme={{
        token: {
          colorPrimary: genericStyles.bgColor,
           controlHeight: 38,
        },
      }}
    >
      {children}
    </ConfigProvider>
  );
};

export default AntdThemeWrapper;
